export const PHONE = 360;
export const TABLET = 600;
export const DESKTOP = 1024;
export const LARGE_DESKTOP = 1400;
